export default {
    SHOW_ACTION: 'SHOW_ACTION',
    HIDE_ACTION: 'HIDE_ACTION',
    SET_SERVICE_FORM_STEP: 'SET_SERVICE_FORM_STEP',
};